"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _Portal = _interopRequireDefault(require("../../../../components/Portal"));
var _Submenu = _interopRequireDefault(require("../Submenu/Submenu"));
var _utils = require("../utils");
var _events = _interopRequireDefault(require("../../../../components/utils/events"));
var _styles = require("./styles");
var _sanitizer = require("../../../utils/sanitizer");
var _menu = require("../../../utils/menu");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const reducer = (state, newState) => ({
  ...state,
  ...newState
});
const MenuGroup = ({
  node,
  level,
  isActive,
  isExpanded,
  history,
  children,
  sectionsView,
  menuRef
}) => {
  var _node$meta, _getVisibleMenuNodes2;
  const [state, setState] = (0, _react.useReducer)(reducer, {
    submenuMaxHeight: 'none',
    submenuPosition: 'top',
    xPosition: 0,
    yPosition: 0,
    open: false
  });
  const nodeRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const memoizedMenuRef = menuRef;
    const closeSubmenu = () => {
      setState({
        open: false
      });
    };
    if (memoizedMenuRef.current) {
      _events.default.on(memoizedMenuRef.current, 'scroll', closeSubmenu);
    }
    return () => {
      if (memoizedMenuRef.current) {
        _events.default.off(memoizedMenuRef.current, 'scroll', closeSubmenu);
      }
    };
  }, [menuRef]);
  const showSubmenu = () => {
    if (isExpanded) {
      var _getVisibleMenuNodes;
      if ((_getVisibleMenuNodes = (0, _menu.getVisibleMenuNodes)(node.children)) !== null && _getVisibleMenuNodes !== void 0 && _getVisibleMenuNodes.length) {
        const submenuParameters = (0, _utils.getSubmenuPosition)(nodeRef.current);
        setState({
          ...submenuParameters,
          open: true
        });
      }
    }
  };
  const hideSubmenu = () => {
    setState({
      open: false
    });
  };
  const sanitizedUri = (0, _react.useMemo)(() => (0, _sanitizer.sanitizeHref)(node.uri), [node.uri]);
  if (node !== null && node !== void 0 && (_node$meta = node.meta) !== null && _node$meta !== void 0 && _node$meta.appframeMenuHide) return null;
  return _react.default.createElement(_styles.MenuGroupContainer, {
    ref: nodeRef,
    onMouseEnter: showSubmenu,
    onFocus: showSubmenu,
    onMouseLeave: hideSubmenu,
    isPopoverOpen: state.open
  }, _react.default.createElement(_MenuItem.default, {
    isActive: isActive,
    title: node.label,
    iconUri: node.icon,
    level: level,
    link: sanitizedUri,
    linkMeta: node.meta,
    isExpanded: isExpanded,
    hasInnerNode: Boolean((_getVisibleMenuNodes2 = (0, _menu.getVisibleMenuNodes)(node === null || node === void 0 ? void 0 : node.children)) === null || _getVisibleMenuNodes2 === void 0 ? void 0 : _getVisibleMenuNodes2.length),
    onArrowIndicatorClick: showSubmenu,
    history: history
  }), state.open && _react.default.createElement(_Portal.default, null, _react.default.createElement(_styles.SubmenuWrapper, {
    style: {
      [state.submenuPosition]: state.yPosition
    },
    leftOffset: state.xPosition
  }, _react.default.createElement(_styles.SubmenuContainer, {
    style: {
      [state.submenuPosition]: state.yPosition,
      maxHeight: state.submenuMaxHeight,
      left: `${state.xPosition}px`,
      display: state.open ? 'block' : 'none'
    }
  }, sectionsView ? _react.default.createElement(_Submenu.default, {
    level: level,
    sections: node.children,
    history: history
  }, children) : children(node.children, level)))));
};
var _default = exports.default = MenuGroup;